import ImportListProductVariantsTab from './ImportListProductVariantsTab'

export default ImportListProductVariantsTab
